// extracted by mini-css-extract-plugin
export default {"perPageContainer":"styles_perPageContainer__Kgc5n","perPageLabel":"styles_perPageLabel__9nrZK"};